import { type ReactNode } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { normalizeEntryUrl } from '@/lib/historyEntries'
import { appendReferrer } from '@/lib/referrerState'

type LinkWithStateProps = {
    to: string
    children: ReactNode
    className?: string
    state?: Record<string, unknown>
}

function LinkWithState({ to, children, className, state }: LinkWithStateProps) {
    const location = useLocation()
    const currentUrl = normalizeEntryUrl(location.pathname, location.search)
    return (
        <Link
            to={to}
            className={className}
            state={{
                ...appendReferrer(location.state, currentUrl),
                ...state
            }}
        >
            {children}
        </Link>
    )
}

export default LinkWithState
